const isWeb = true;
const isMRN = false;
import { getAppVersion } from '@nibfe/mkt-env-api';
export function compareVersion(v1, v2) {
    const arr1 = v1.split('.');
    const arr2 = v2.split('.');
    const len = Math.max(arr1.length, arr2.length);
    while (arr1.length < len) {
        arr1.push('0');
    }
    while (arr2.length < len) {
        arr2.push('0');
    }
    for (let i = 0; i < len; i++) {
        const num1 = parseInt(arr1[i]);
        const num2 = parseInt(arr2[i]);
        if (num1 > num2) {
            return 1;
        }
        else if (num1 < num2) {
            return 0;
        }
    }
    return 1;
}
export const MTNewDigitalDisplayStyle = isMRN && compareVersion(getAppVersion(), '12.33.400') === 0 ? {} : {
    fontFamily: 'MTNewDigitalDisplay-Bold'
};
/**
 * 将时间戳转换为年月日格式
 * @param timestamp 时间戳（毫秒）
 * @param separator 日期分隔符，默认为 '-'
 * @returns 年月日对象
 */
export function formatTimestampToDate(timestamp) {
    try {
        const date = new Date(timestamp);
        const year = String(date.getFullYear());
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return {
            year,
            month,
            day
        };
    }
    catch (error) {
        return {
            year: '',
            month: '',
            day: ''
        };
    }
}
export const convertCentsToYuan = (cents, fixed = 1) => {
    if (typeof cents !== 'number' || isNaN(cents)) {
        return {
            integerPart: '',
            decimalPart: ''
        };
    }
    // 避免四舍五入，使用向下取整
    const multiplier = Math.pow(10, fixed);
    const yuan = Math.floor(cents / 100 * multiplier) / multiplier;
    const yuanStr = yuan.toFixed(fixed);
    const [integerPart, decimalPart] = yuanStr.split('.');
    return {
        integerPart,
        decimalPart,
        str: `${integerPart}.${decimalPart}`
    };
};
/**
 * 格式化券门槛文案
 * @param requireAmount 原始门槛文案
 * @returns 格式化后的门槛文案，如 "满800可用"
 */
export function formatRequireAmount(requireAmount) {
    if (!requireAmount) {
        return '无门槛';
    }
    // 去除"元"字
    let amount = requireAmount.replace(/元/g, '');
    // 确保以"满"开头
    let result = amount.startsWith('满') ? amount : `满${amount}`;
    // 确保以"可用"结尾
    result = result.endsWith('可用') ? result : `${result}可用`;
    return result;
}
